// extracted by mini-css-extract-plugin
export var aircallIframe = "_kt-3";
export var fabContainer = "_kt-5";
export var fabRinging = "_kt-6";
export var loadingOverlay = "_kt-4";
export var pulse = "_kt-7";
export var widgetContent = "_kt-2";
export var widgetPanel = "_kt-0";
export var widgetPanelExpanded = "_kt-1";